import {
  IPostRequiredActionDismissParams,
  IShiftRequiredAction,
} from '@src/models/GigSchedule'
import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import { IPayload } from 'models/Global'

export class RequiredActionsApi {
  constructor(private axios: AxiosService) {}

  getRequiredActions = async () => {
    const response = await this.axios.get<IPayload<IShiftRequiredAction[]>>(
      Endpoints.getRequiredActions,
    )
    return response
  }

  postRequiredActionDismiss = async (
    params: IPostRequiredActionDismissParams,
  ) => {
    const response = await this.axios.post<IPayload<{}>>(
      Endpoints.postRequiredActionDismiss,
      params,
    )
    return response
  }
}
